module.exports = __webpack_public_path__ + "static/media/1.22296fdb.jpg";